import http from './utils';
import { prefix } from './constants';
import axios from 'axios';
const { CancelToken } = axios;

export const requestAiTaskList: (
  payload: any,
  cancelTokenFunc?: any,
) => Promise<any> | any = (payload, cancelTokenFunc = () => {}) => {
  return http({
    url: `${prefix}/ai_task_center/all_summary_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

export const requestAiGameList: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_task_center/summary_game_filter`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const requestAiTabState: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_task_center/all_summary_stats`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const requestAiTaskCenterRepeat: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_task_center/all_repeat_summary_list`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const unsubscribeGlobalRepeat: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${prefix}/global/unsubscribe`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

export const getUnsubscribeGlobalState: (
  payload: any,
) => Promise<any> = payload => {
  return http({
    url: `${prefix}/global/get_unsubscribe`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 暂停关键词分析任务
 * @param payload - { edition_unified_id, entity_type, id_type, task_id }
 * @returns Promise<{ message, task_id, task_status, ret_code }>
 */
export const pauseKeywordAnalysisTask: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/pause_keyword_analysis_task`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 恢复关键词分析任务
 * @param payload - { edition_unified_id, entity_type, id_type, task_id }
 * @returns Promise<{ message, task_id, task_status, ret_code }>
 */
export const resumeKeywordAnalysisTask: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/resume_keyword_analysis_task`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 查询 Prompt 收藏列表
 * @param payload - { edition_unified_id, page, page_size }
 * @returns Promise<{ total, list: IPromptCollectItem[] }>
 */
export const getPromptCollectList: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/prompt_collect/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 创建 Prompt 收藏
 * @param payload - { edition_unified_id, prompt_name, prompt_detail }
 */
export const createPromptCollect: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/prompt_collect/create`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 更新 Prompt 收藏
 * @param payload - { id, edition_unified_id, prompt_name, prompt_detail }
 */
export const updatePromptCollect: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/prompt_collect/update`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 删除 Prompt 收藏（软删除）
 * @param payload - { id, edition_unified_id }
 */
export const deletePromptCollect: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/prompt_collect/delete`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

/**
 * 应用 Prompt 收藏（自增使用次数）
 * @param payload - { id, edition_unified_id }
 */
export const applyPromptCollect: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/prompt_collect/apply`,
    method: 'post',
    data: payload,
  });
};

/*
 * 暂停Custom分析任务
 * @param payload - { edition_unified_id, entity_type, id_type, task_id }
 * @returns Promise<{ message, task_id, task_status, ret_code }>
 */
export const pauseCustomAITask: (
  payload: any,
) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/ai_analysis/pause_repeat_summary_task`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};
